import handleActions from './handleActions';

export {
    handleActions
};
